import React from 'react'
import { connectStats } from 'react-instantsearch-dom'
import { Text } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'
import qs from 'qs'

/**
 * Displays the number of results and time taken
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/clear-refinements/react/
 *
 * @param {number} nbHits - The list of hits matching the current search results
 *
 * @returns {function} - React Component
 */
const StatsComponent = ({ nbHits }) => {
  const { query = '' } = qs.parse(location.search.slice(1))

  return (
    <Text>
      {nbHits} results found{query && ` for "${decodeURIComponent(query)}"`}
    </Text>
  )
}

StatsComponent.propTypes = {
  nbHits: PropTypes.number,
}

export const Stats = connectStats(StatsComponent)
